import { Chip, ChipProps, Typography, css, styled } from "@mui/material";
import { FC } from "react";

import { text } from "@/modules/irohana-components/theme/colors-new";
import { typography } from "@/modules/irohana-components/theme/typography";
import { rounded } from "@/modules/irohana-components/theme/variables";
export type TTagNewVariant = "regular" | "light";

type TTagNewBaseProps = {
  textColor?: string;
  borderColor?: string;
  title: string;
  fontWeight?: number;
} & Omit<ChipProps, "variant" | "color">;

type TTagNewRegularProps = TTagNewBaseProps & {
  variant?: "regular";
  color: string;
  backgroundColor?: string;
};

type TTagNewLightProps = TTagNewBaseProps & {
  variant: "light";
  color: string;
  backgroundColor: string;
};

export type TTagNewProps = TTagNewRegularProps | TTagNewLightProps;

export const TagNew: FC<TTagNewProps> = ({ variant = "regular", color, backgroundColor, title, textColor, borderColor, fontWeight, ...rest }) => {
  return (
    <StyledChip
      chipVariant={variant}
      bgColor={backgroundColor || color}
      borderColor={borderColor}
      label={
        <StyledTypography>
          {variant === "light" && <StyledPoint background={color} />}
          <Typography
            style={{
              color: textColor,
              fontWeight: fontWeight,
            }}
          >
            {title}
          </Typography>
        </StyledTypography>
      }
      {...rest}
    />
  );
};

const options = { shouldForwardProp: (propName: string) => !["chipVariant", "bgColor", "borderColor"].includes(propName) };

const StyledChip = styled(Chip, options)<{ chipVariant: TTagNewVariant; bgColor: string; borderColor?: string }>`
  ${({ chipVariant }) => (chipVariant === "regular" ? RegularTagCSS : LightTagCSS)};
  background-color: ${({ bgColor }) => bgColor};
  ${({ borderColor }) => borderColor && `border: 1px solid ${borderColor};`}
`;

const RegularTagCSS = css`
  border-radius: ${rounded.md};
  .MuiTypography-root {
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    color: ${text.primary};
  }
`;

const LightTagCSS = css`
  border-radius: ${rounded.lg};
  .MuiTypography-root {
    font-size: 14px;
    color: ${text.primary};
  }
`;

const StyledTypography = styled("span")`
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  ${css(typography.body14)}
`;

const StyledPoint = styled("span")<{ background: string }>`
  width: 8px;
  height: 8px;
  border-radius: ${rounded.full};
  background-color: ${({ background }) => background};
`;
